import React from "react";
import Layout from "@/components/Layout";
import SectionHeader from "@/components/SectionHeader";
import { useI18n } from "@/i18n";
import { MessageSquare, Stethoscope, Save, Code2, Cpu, FlaskConical, Handshake } from "lucide-react";

export default function Process() {
  const { t } = useI18n();
  const steps = t("process.steps");
  const icons = [MessageSquare, Stethoscope, Save, Code2, Cpu, FlaskConical, Handshake];

  return (
    <Layout seoTitle={t("process.title")} seoDescription={t("process.subtitle")}>
      <section className="section-y">
        <div className="container-mt">
          <SectionHeader as="h1" num="01" kicker="Workflow" title={t("process.title")} subtitle={t("process.subtitle")} />

          <div className="relative">
            {/* Continuous vertical gradient line — desktop only */}
            <div
              className="absolute left-6 md:left-1/2 top-4 bottom-4 w-px pointer-events-none hidden sm:block"
              style={{
                background: "linear-gradient(180deg, rgba(163,230,53,0.6), rgba(163,230,53,0.15) 30%, rgba(255,255,255,0.05) 70%, transparent)",
              }}
              aria-hidden="true"
            />
            <ol className="space-y-4 md:space-y-6">
              {steps.map((s, i) => {
                const Icon = icons[i % icons.length];
                const isRight = i % 2 === 1;
                return (
                  <li
                    key={i}
                    data-testid={`process-step-${i + 1}`}
                    className={`relative flex flex-col sm:flex-row items-start gap-6 sm:gap-8 ${isRight ? "sm:flex-row-reverse sm:text-right" : ""}`}
                  >
                    {/* Timeline node */}
                    <div className="absolute left-6 sm:left-1/2 top-6 -translate-x-1/2 z-10">
                      <div className="w-4 h-4 rounded-full bg-brand-lime shadow-[0_0_0_6px_rgba(163,230,53,0.15)]" />
                    </div>

                    {/* Card */}
                    <div className={`w-full sm:w-[calc(50%-2rem)] pl-14 sm:pl-0 ${isRight ? "sm:pr-8" : "sm:pl-8"}`}>
                      <div className="card-mt card-mt-pad">
                        <div className={`flex items-center gap-4 mb-4 ${isRight ? "sm:flex-row-reverse" : ""}`}>
                          <span className="num-chip">{String(i + 1).padStart(2, "0")}</span>
                          <div className="icon-tile !w-10 !h-10">
                            <Icon size={16} />
                          </div>
                        </div>
                        <h2 className="h-display text-2xl md:text-3xl text-white mb-2">{s.t}</h2>
                        <p className="text-zinc-400 leading-relaxed">{s.d}</p>
                      </div>
                    </div>
                  </li>
                );
              })}
            </ol>
          </div>
        </div>
      </section>
    </Layout>
  );
}
